// D80 Tier 2 — Code block NodeView (language dropdown + copy button).
// Used by `@tiptap/extension-code-block-lowlight` to render a small
// header bar above the <pre><code> with a language picker and a
// "Copy" button. The dropdown options correspond to lowlight's
// registered grammars — keep them sorted; "plaintext" is the default.
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import { useState } from 'react';
import { Copy as CopyIcon, Check } from 'lucide-react';

export const CODE_LANGUAGES = [
  ['plaintext', 'Plain text'],
  ['bash', 'Bash'],
  ['c', 'C'],
  ['cpp', 'C++'],
  ['csharp', 'C#'],
  ['css', 'CSS'],
  ['diff', 'Diff'],
  ['dockerfile', 'Dockerfile'],
  ['go', 'Go'],
  ['graphql', 'GraphQL'],
  ['html', 'HTML'],
  ['ini', 'INI'],
  ['java', 'Java'],
  ['javascript', 'JavaScript'],
  ['json', 'JSON'],
  ['kotlin', 'Kotlin'],
  ['markdown', 'Markdown'],
  ['php', 'PHP'],
  ['python', 'Python'],
  ['ruby', 'Ruby'],
  ['rust', 'Rust'],
  ['shell', 'Shell'],
  ['sql', 'SQL'],
  ['swift', 'Swift'],
  ['typescript', 'TypeScript'],
  ['xml', 'XML'],
  ['yaml', 'YAML'],
];

export function CodeBlockNodeView(props) {
  const { node, updateAttributes, editor, getPos } = props;
  const lang = (node.attrs.language || 'plaintext').toLowerCase();
  const [copied, setCopied] = useState(false);

  const copyCode = async () => {
    try {
      const pos = getPos();
      const nodeText = editor.state.doc.nodeAt(pos)?.textContent || node.textContent || '';
      await navigator.clipboard.writeText(nodeText);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Fallback: select the <code> block contents.
      setCopied(false);
    }
  };

  return (
    <NodeViewWrapper as="div" data-type="code-block" className="stellar-codeblock">
      <div className="stellar-codeblock-head" contentEditable={false}>
        <select
          value={lang}
          onChange={(e) => updateAttributes({ language: e.target.value })}
          className="stellar-codeblock-lang"
          data-testid="codeblock-language"
        >
          {CODE_LANGUAGES.map(([v, l]) => (
            <option key={v} value={v}>{l}</option>
          ))}
        </select>
        <button
          type="button"
          onMouseDown={(e) => e.preventDefault()}
          onClick={copyCode}
          className="stellar-codeblock-copy"
          data-testid="codeblock-copy"
          aria-label="Copy code"
        >
          {copied ? <Check size={12} /> : <CopyIcon size={12} />}
          <span>{copied ? 'Copied' : 'Copy'}</span>
        </button>
      </div>
      <pre className="stellar-codeblock-pre"><NodeViewContent as="code" /></pre>
    </NodeViewWrapper>
  );
}
